angular.module('ui.user.notifications', [])

    .config(function ($stateProvider, customTemplateResolverProvider) {
        $stateProvider.state('client.notifications', {
            url: '/notifications',
            template: customTemplateResolverProvider.get('notifications.html', 'app/ui/user/notifications/notifications.html'),
            controller: 'UserNotificationsController',
            data: {pageTitle: 'OrderManager: Notifications'}
        });

    })

    .controller('UserNotificationsController', function ($scope, $state) {


    })

;